import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { ChangeEvent, FC } from 'react';
import MaterialTextField from 'src/components/material/textField';
import styles from './CommonField.module.scss';

interface CommonFiledProps {
  title?: string;
  description?: string;
  anchor?: string;
  placeholder?: string;
  charactersLength?: number;
  type?: 'textarea' | 'input';
  isIcon?: boolean;
  value?: string;
  error?: string;
  onChange?: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const CommonField: FC<CommonFiledProps> = ({
  title,
  description,
  anchor,
  placeholder,
  charactersLength = 100,
  type = 'input',
  isIcon,
  value,
  error,
  onChange,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        {/* {isIcon && (
          <div>
            <a
              href={`/how-it-works#${anchor}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InfoOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
            </a>
          </div>
        )} */}
      </div>
      <div className={styles.description}>{description}</div>
      <div>
        {type === 'textarea' ? (
          <TextareaAutosize
            className={styles.textarea}
            minRows={2}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        ) : (
          <MaterialTextField
            variant="outlined"
            color="primary"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        )}
      </div>
      <small className={styles.formHint}>
        {error && <span className={styles.invalidFeedback}>{error}</span>}
        <span className={styles.charactersLength}>
          {value?.length ?? 0}/{charactersLength}
        </span>
      </small>
    </div>
  );
};
